// import { dialog } from "../../nq-component";
// import Filter from "../Filter/Filter";
// import classNames from "../../classNames";

// let timeout;

// function Search({ className, schemas, fields, onSubmit, onValueChange }) {
//   function onChange(value) {
//     // SEND VALUE TO PARENT
//     if (onValueChange) {
//       onValueChange(value);
//     }
//     const where = {};
//     clearTimeout(timeout);
//     const or = [];
//     Object.keys(fields).forEach((field) => {
//       const options = fields[field];
//       if (options.type === "String") {
//         const query = {};
//         query[field] = { $regex: value, $options: "i" };
//         or.push(query);
//       } else if (options.type === "Boolean") {
//         const query = {};
//         query[field] = value === "true";
//         or.push(query);
//       } else if (options.type === "Pointer") {
//         const query = {};
//         query[field] = { $eq: value }; // Assuming `value` is the object ID to search for
//         or.push(query);
//       }
//     });
//     where.$or = or;
//     timeout = setTimeout(() => {
//       onSubmit(where);
//     }, 300);
//   }

//   function onClickFilter() {
//     function _onSubmit(where) {
//       dialog.close();
//       onSubmit(where);
//     }

//     dialog.fire({
//       html: (
//         <Filter
//           schemas={schemas}
//           fields={fields}
//           onSubmit={_onSubmit}
//           onCancel={() => dialog.close()}
//         />
//       ),
//       footer: false,
//     });
//   }

//   return (
//     <div className={classNames("input-group", className)}>
//       <i
//         className="bi bi-search position-absolute"
//         style={{
//           zIndex: 4,
//           width: "50px",
//           height: "50px",
//           lineHeight: "40px",
//           textAlign: "center",
//         }}
//       />
//       <input
//         onChange={(e) => onChange(e.target.value)}
//         type="search"
//         className="form-control rounded-pill ps-5 "
//         placeholder="Search"
//         style={{ width: "100px" }}
//       />
//     </div>
//   );
// }

// export default Search;
// // <button
// //       onClick={onClickFilter}
// //       className="btn btn-link border-0 p-0 ms-1 d-flex align-items-center"
// //       type="button"
// //     >
// //       <i className="bi bi-filter fs-4"></i>Filter
// //     </button>

import { useMemo, useRef, useState } from "react";
import { dialog } from "../../nq-component";
import Filter from "../Filter/Filter";
import classNames from "../../classNames";

let timeout;

function Search({ className, schemas, fields, onSubmit, onValueChange }) {
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  function buildWhere(v) {
    const where = {};
    const or = [];

    Object.keys(fields).forEach((field) => {
      const options = fields[field];

      if (options.type === "String") {
        or.push({ [field]: { $regex: v, $options: "i" } });
      } else if (options.type === "Boolean") {
        or.push({ [field]: v === "true" });
      } else if (options.type === "Pointer") {
        or.push({ [field]: { $eq: v } });
      }
    });

    where.$or = or;
    return where;
  }

  function onChange(v) {
    setValue(v);

    // SEND VALUE TO PARENT
    if (onValueChange) onValueChange(v);

    clearTimeout(timeout);
    const where = buildWhere(v);

    timeout = setTimeout(() => {
      onSubmit(where);
    }, 300);
  }

  function clear() {
    onChange("");
    requestAnimationFrame(() => inputRef.current?.focus());
  }

  function onClickFilter() {
    function _onSubmit(where) {
      dialog.close();
      onSubmit(where);
    }

    dialog.fire({
      html: (
        <Filter
          schemas={schemas}
          fields={fields}
          onSubmit={_onSubmit}
          onCancel={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  return (
    <div className={classNames("w-100", className)}>
      <div
        className="position-relative d-flex align-items-center bg-white border rounded-4 shadow-sm"
        style={{
          minHeight: 46,
          transition: "box-shadow .2s ease, border-color .2s ease",
        }}
      >
        {/* Search icon */}
        <i
          className="bi bi-search text-muted position-absolute"
          style={{
            left: 14,
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: 16,
          }}
        />

        {/* Input */}
        <input
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          // type="search"
          className="form-control border-0 bg-transparent"
          placeholder="Search..."
          style={{
            paddingLeft: 42,
            paddingRight: 96, // space for buttons
            height: 46,
            borderRadius: 16,
            boxShadow: "none",
          }}
        />

        {/* Right actions */}
        <div
          className="position-absolute d-flex align-items-center gap-1"
          style={{ right: 8 }}
        >
          {/* Clear (only if has value) */}
          {value ? (
            <button
              type="button"
              className="btn btn-sm btn-light rounded-circle"
              onClick={clear}
              style={{ width: 34, height: 34 }}
              aria-label="Clear search"
              title="Clear"
            >
              <i className="bi bi-x-lg" />
            </button>
          ) : null}

          {/* Filter button (WOW factor) */}
          {/* <button
            type="button"
            className="btn btn-sm btn-outline-secondary rounded-pill d-flex align-items-center gap-2"
            onClick={onClickFilter}
            style={{ height: 34, paddingInline: 12 }}
            title="Advanced filters"
          >
            <i className="bi bi-funnel" />
            <span className="d-none d-md-inline">Filter</span>
          </button> */}
        </div>
      </div>

      {/* Optional hint row */}
      {/* <div className="d-flex justify-content-between mt-1">
        <small className="text-muted">
          Tip: Try searching barcode, SKU, or product name
        </small>
      </div> */}
    </div>
  );
}

export default Search;
